import { MapObjectProperties } from "@iventis/map-types";
import GeoJSON from "geojson";
import { Content } from "@iventis/translations/content/typed-content";
import { Body2 } from "@iventis/styles/src/components/texts";
import React, { FunctionComponent, useMemo } from "react";
import { styled } from "@iventis/styles";
import { getAreaInAppropriateUnits } from "@iventis/map-engine/src/utilities/geojson-helpers";
import { thousandSeparator } from "@iventis/utilities";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { contentCss } from "./analysis.helpers";

export const AnalysisAreaComponent: FunctionComponent<{ feature: GeoJSON.Feature<GeoJSON.Polygon, MapObjectProperties>; unitOfMeasurement: UnitOfMeasurement }> = ({
    feature,
    unitOfMeasurement,
}) => {
    const translate = useIventisTranslate();

    const area = useMemo(() => getAreaInAppropriateUnits(feature, unitOfMeasurement), [feature]);

    return (
        <StyledContent>
            <Body2 className="bold">{translate(Content.map2.analysis.area_content.title)}</Body2>
            <Body2 data-testid="area-analysis-result">{thousandSeparator(area)}</Body2>
        </StyledContent>
    );
};

const StyledContent = styled.div`
    ${contentCss}
`;
